var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('div',{ref:"chart"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }